<div
  class="lightbox-container"
  [ngClass]="asideContent ? 'has-aside-content' : ''"
>
  <button
    class="btn btn-round ml-auto close-button"
    data-e2e="lightbox-close-button"
    (click)="closeLightBox()"
  >
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>

  <atx-carousel
    [items]="mediaList"
    thumbnailsNumber="0"
    class="carousel"
    [ngClass]="asideContent ? 'my-3 height-100' : 'mt-3'"
    [selectIndex]="selectedIndex"
    [showControls]="false"
  >
    <ng-template atxCarouselSlide let-currentMedia="item" let-active="index">
      <div
        class="d-flex flex-column test"
        [ngClass]="{
          'flex-column  align-items-center': !asideContent,
          'flex-row-reverse justify-content-end h-100': asideContent
        }"
      >
        @if (currentMedia.type !== mediaType.IMAGE360) {
        <atx-media
          class="current-media"
          [media]="currentMedia"
          [atxImageZoom]="
            currentMedia.type === mediaType.VIDEO ? null : currentMedia.url
          "
          [maxWidth]="maxWidth"
          [videoPlayerProps]="videoPlayerProps"
          [imageBreakpoints]="imageBreakPoints"
          [objectFit]="
            currentMedia.type === mediaType.VIDEO
              ? MediaObjectFit.COVER
              : MediaObjectFit.CONTAIN
          "
          fallbackImageUrl="static/images/placeholder-image.jpg"
          data-e2e="lightbox-current-media"
        ></atx-media>
        } @if ((isMobile$ | async) === false) { @if (currentMedia.type ===
        mediaType.IMAGE360) {
        <atx-media-360
          class="current-media"
          [rotateOnReady]="true"
          [media]="currentMedia"
          [atxImageZoom]="current360ImageUrl"
          [maxWidth]="maxWidth"
          [imageBreakpoints]="imageBreakPoints"
          fallbackImageUrl="static/images/placeholder-image.jpg"
          data-e2e="lightbox-current-media"
          (imageClick)="current360ImageUrl = $event"
        ></atx-media-360>
        } }

        <div
          class="thumbnail-container mt-3"
          [ngClass]="{
            'mh-100 flex-shrink-0 mr-1 mt-0': asideContent,
            'mt-3': !asideContent
          }"
        >
          @for (media of mediaList; track media; let i = $index) {
          <div
            class="thumbnail"
            data-e2e="lightbox-media-thumbnail"
            [class.active]="i == active"
            (click)="selectedIndex = i"
          >
            @if (media.type === mediaType.VIDEO) {
            <atx-image
              class="video"
              [imageUrl]="media.url"
              objectFit="contain"
              [maxWidth]="maxWidth"
              [imageBreakpoints]="imageBreakPoints"
              fallbackImageUrl="static/images/play-button.png"
              videoPosterUrl="static/images/play-button.png"
            ></atx-image>
            } @else {
            <atx-image
              [imageUrl]="media.url"
              objectFit="cover"
              [maxWidth]="maxWidth"
              [imageBreakpoints]="imageBreakPoints"
            ></atx-image>
            }
          </div>
          }
        </div>
      </div>
    </ng-template>
  </atx-carousel>

  @if (asideContent) {
  <div class="aside-content px-4">
    <ng-container *ngTemplateOutlet="asideContent"></ng-container>
  </div>
  }
</div>
